import React from 'react';
import { StyledPipaMainProduct } from './styles';

export type IPipaMainProductProps = {
  quantityDisplay: string;
  isMainProduct: boolean;
  textColor: string;
  strokedSaleQuantity?: string;
};

export const PipaMainProduct: React.FC<IPipaMainProductProps> = ({
  quantityDisplay,
  isMainProduct,
  textColor,
  strokedSaleQuantity = '',
}) => {
  return (
    <StyledPipaMainProduct textColor={textColor}>
      {quantityDisplay}
      {isMainProduct && <p className="stroked">{strokedSaleQuantity}</p>}
    </StyledPipaMainProduct>
  );
};
